export default {
    "helloVisitor": "Hola, Visitante",
    "hello": "Hola, {name}",
    "points": "puntos",
    "loginButton": "Iniciar sesión",
    "rewardsTitle": "Recompensas",
    "rewardsSubtitle": "Cambia tus puntos por recompensas",
    "rewardsEmpty": "No hay recompensas disponibles en este momento.",
    "activeCoupons": "Cupones activos",
    "couponAvailable": "Disponible",
    "couponValidUntil": "Válido hasta {date}",
    "copyCode": "Copiar código",
    "codeCopied": "¡Código copiado!",
    "rewardUnavailable": "No disponible",
    "rewardPoints": "{points} puntos",
    "rewardRedeemed": "Canjeada",
    "rewardExclusive": "Recompensa exclusiva para clientes",
    "missingPoints": "Faltan {points} puntos",
    "missingOnePoint": "Falta 1 punto",
    "useNow": "Usar ahora",
    "redeemTitle": "¿Cambiar {points} puntos por \"{name}\"?",
    "redeemMessage": "Esto reducirá tu saldo en {points} puntos.",
    "redeemConfirm": "Confirmar",
    "redeemCancel": "Cancelar",
    "redeemClose": "Cerrar",
    "redeemSuccessTitle": "¡Recompensa canjeada!",
    "redeemSuccessMessage": "Recompensa canjeada con éxito. Consulta al establecimiento para utilizarla.",
    "redeemSuccessHome": "Pantalla inicial",
    "redeemError": "No pudimos canjearla ahora, inténtalo de nuevo.",
    "redeemErrorPointsProgramInactive": "El programa de puntos no está disponible en este momento.",
    "redeemErrorStaffOnly": "Esta recompensa solo puede canjearse en el establecimiento.",
    "redeemErrorRewardUnavailable": "Esta recompensa ya no está disponible.",
    "redeemErrorRecentRedemption": "Acabas de canjear esta recompensa, espera 1 minuto e inténtalo de nuevo.",
    "redeemErrorInsufficientPoints": "No tienes puntos suficientes.",
    "yourPoints": "Tus puntos:",
    "loginToSeePoints": "Inicia sesión para ver tus puntos",
    "howToUse": "¿Cómo usar esta recompensa?",
    "back": "Volver",
    "redeemReward": "Canjear recompensa",
    "insufficientPoints": "Puntos insuficientes",
    "loginToRedeem": "Inicia sesión para canjear",
    "confirmRedeemTitle": "¿Deseas canjear?",
    "redeemStaffTitle": "Cómo canjear",
    "balanceAfter": "Tu saldo tras el canje:",
    "faqTitle": "Preguntas Frecuentes",
    "faqOthers": "Otras Preguntas",
    "faqSearch": "Buscar",
    "faqEmpty": "Todavía no hay preguntas registradas.",
    "faqNoResults": "No encontramos preguntas para esa búsqueda.",
    "bannerSlide": "Banner {index} de {total}",
    "modalClose": "Cerrar",
    "termsTitle": "Términos de uso",
    "termsAccept": "Leí y acepto los términos de uso",
    "termsEmpty": "Todavía no hay términos de uso publicados.",
    "statementTitle": "Extracto",
    "statementBalance": "Saldo de Puntos:",
    "statementEmpty": "Todavía no hay movimientos por aquí.",
    "statementDateLine": "{date} a las {time} - {weekday}",
    "statementReceived": "¡Ganaste {points} puntos!",
    "statementReceivedOne": "¡Ganaste 1 punto!",
    "statementUsed": "¡Usaste {points} puntos!",
    "statementUsedOne": "¡Usaste 1 punto!",
    "statementReward": "Recompensa: {name}",
    "statementPurchase": "Compra hecha {date}",
    "statementAddedBy": "Puntos añadidos por: {name}",
    "statementAdded": "Puntos añadidos",
    "statementExpand": "Expandir extracto",
    "statementCollapse": "Contraer extracto",
    "menuStatement": "Extracto",
    "menuFaq": "Preguntas frecuentes",
    "menuTerms": "Términos de uso",
    "menuRules": "Reglas",
    "rulesTitle": "Reglas del programa",
    "menuLogout": "Salir",
    "tabPoints": "Puntos",
    "tabCashback": "Cashback",
    "tabReferral": "Referidos",
    "comingSoon": "Próximamente"
};
